export const FETCH_HL7_SENT_MESSAGES = "[ADMIN] FETCH_HL7_SENT_MESSAGES";
export const FETCH_HL7_SENT_MESSAGES_START = "[ADMIN] FETCH_HL7_SENT_MESSAGES_START";
export const FETCH_HL7_SENT_MESSAGES_SUCCESS = "[ADMIN] FETCH_HL7_SENT_MESSAGES_SUCCESS";
export const FETCH_HL7_SENT_MESSAGES_ERROR = "[ADMIN] FETCH_HL7_SENT_MESSAGES_ERROR";

export const RESEND_HL7_SENT_MESSAGE = "[ADMIN] RESEND_HL7_SENT_MESSAGE";
export const RESEND_HL7_SENT_MESSAGE_START = "[ADMIN] RESEND_HL7_SENT_MESSAGE_START";
export const RESEND_HL7_SENT_MESSAGE_SUCCESS = "[ADMIN] RESEND_HL7_SENT_MESSAGE_SUCCESS";
export const RESEND_HL7_SENT_MESSAGE_ERROR = "[ADMIN] RESEND_HL7_SENT_MESSAGE_ERROR";

export const SEARCH_HL7_SENT_MESSAGES = "[ADMIN] SEARCH_HL7_SENT_MESSAGES";
export const SEARCH_HL7_SENT_MESSAGES_START = "[ADMIN] SEARCH_HL7_SENT_MESSAGES_START";
export const SEARCH_HL7_SENT_MESSAGES_SUCCESS = "[ADMIN] SEARCH_HL7_SENT_MESSAGES_SUCCESS";
export const SEARCH_HL7_SENT_MESSAGES_ERROR = "[ADMIN] SEARCH_HL7_SENT_MESSAGES_ERROR";

export const SHOW_ACKNOWLEDGEMENT_MODAL = "[ADMIN] SHOW_ACKNOWLEDGEMENT_MODAL";
export const CLOSE_ACKNOWLEDGEMENT_MODAL = "[ADMIN] CLOSE_ACKNOWLEDGEMENT_MODAL";


export const fetchAllHL7SentMessages = (payload) => {
    return {
        type: FETCH_HL7_SENT_MESSAGES,
        payload
    };
};

export const resendHL7SentMessage = (id) => {
    return {
        type: RESEND_HL7_SENT_MESSAGE,
        id
    };
};

export const searchHL7SentMessages = (payload) => {
    return {
        type: SEARCH_HL7_SENT_MESSAGES,
        payload
    };
};

export const showAcknowledgementModal = (selectedRow) => { //console.log("SR>.", selectedRow)
    return {
        type: SHOW_ACKNOWLEDGEMENT_MODAL,
        selectedRow
    };
};

export const closeAcknowledgementModal = () => {
    return {
        type: CLOSE_ACKNOWLEDGEMENT_MODAL
    };
};
